import { Injectable } from "@angular/core";
import { fromEvent, map, Observable, startWith } from "rxjs";
import { IVisibilityStateService } from "./IVisibilityState.service";


const visibility = fromEvent(document, "visibilitychange").pipe(
  startWith(null),
  map(() => (document.visibilityState === "hidden") == false)
);

@Injectable()
export class VisibilityStateService implements IVisibilityStateService {
    VisibilityState(): Observable<boolean> {
      return visibility;
    }
  
}
